import type {
  Bono,
  ComparisonRow,
  CostRow,
  FaqItem,
  PainPoint,
  Plan,
  Testimonial,
  Tomo,
} from '../types/content'

/** Product mockup used in the hero and the product overview block. */
export const productMockupUrl =
  'https://cdn.magicpatterns.com/uploads/ibHPesAmQ7bNN2EUsuuotE/MOCKUP_PNG.png'

export const tomos: Tomo[] = [
  {
    id: 1,
    emoji: '📘',
    label: 'Tomo 1',
    title: 'El Método Definición Inteligente',
    description:
      'La filosofía completa: mínimo efectivo, reducción de decisiones, medición inteligente y progreso real.',
  },
  {
    id: 2,
    emoji: '📗',
    label: 'Tomo 2',
    title: 'Comida Simple para Definir',
    description:
      'Recortes inteligentes sin pesada: método por unidades, método por manos, comidas argentinas adaptadas y delivery inteligente.',
  },
  {
    id: 3,
    emoji: '📙',
    label: 'Tomo 3',
    title: 'Rutinas Cortas para Cuerpo Definido',
    description:
      'Entrenamientos de 45, 25 y 10 minutos. Rutinas A/B/C según tiempo disponible: fuerza, control y definición.',
  },
  {
    id: 4,
    emoji: '📕',
    label: 'Tomo 4',
    title: 'Anatomía del Abdomen Definido',
    description:
      'Cómo funcionan tus abdominales: recto, oblicuos y transverso. Ejercicios por nivel y progresiones reales.',
  },
  {
    id: 5,
    emoji: '📓',
    label: 'Tomo 5',
    title: 'Reglas Sin Fricción',
    description:
      'Decisiones predeterminadas: qué hacer si no hay tiempo, si no cocinaste, si comiste de más o si estás cansado.',
  },
  {
    id: 6,
    emoji: '📔',
    label: 'Tomo 6',
    title: 'Plan 8 Semanas',
    description:
      'Tu calendario paso a paso: semanas de base, construcción, intensificación y consolidación. Medición final incluida.',
  },
]

export const tomoIncludes: string[] = [
  'Explicación clara (no técnica)',
  'Rutinas y protocolos listos para usar',
  'Progresiones paso a paso',
  'Trackers y métricas de seguimiento',
  'Solución de problemas reales',
  'Adaptación según tu nivel',
  '100% alineado a fisiología real',
]

export const bonos: Bono[] = [
  {
    id: '01',
    title: 'Checklist Diario de Definición Inteligente',
    description:
      'La hoja de control para saber si estás haciendo lo que mueve la aguja.',
    value: '$2.500',
  },
  {
    id: '02',
    title: 'Plan de Emergencia para Semanas Difíciles',
    description:
      'Qué hacer cuando no hay tiempo, no cocinaste, dormiste mal o querés abandonar.',
    value: '$3.000',
  },
  {
    id: '03',
    title: 'Guía de Sustituciones Inteligentes',
    description:
      'Cambios simples para bajar calorías sin dejar de comer lo que ya comés.',
    value: '$2.500',
  },
  {
    id: '04',
    title: 'Guía de Suplementos Sin Humo',
    description:
      'Qué puede ayudarte, qué es opcional y qué productos no valen tu plata.',
    value: '$3.000',
  },
  {
    id: '05',
    title: 'Lista de Compras Minimalista para Definir',
    description:
      'Lo mínimo que necesitás tener en casa para comer simple y sostener el plan.',
    value: '$2.000',
  },
]

export const bonosTotalValue = '$12.500'

export const painPoints: PainPoint[] = [
  {
    title: 'Rutinas complicadas que no sostenés',
    description:
      'Entrenamientos de 60 minutos, 5 días por semana. Perfecto en papel. Imposible en la vida real.',
  },
  {
    title: 'Comida pesada que genera fricción',
    description:
      '“Pesá todo.” “Calculá macros.” “Prepará tuppers.” Abandonás en la Semana 2.',
  },
  {
    title: 'Información contradictoria sobre abdomen',
    description:
      '¿Hago 1000 abdominales? ¿Evito carbohidratos? ¿Hay quemagrasas que funcionan? Confundido, gastás plata en humo.',
  },
  {
    title: 'Sin diferencia entre principiante e intermedio',
    description:
      'El mismo plan para todos. Algunos lo abandonan. Otros no ven progreso.',
  },
  {
    title: 'Sin reglas para cuando se complica',
    description:
      'No cocinaste. No dormiste. Comiste de más. ¿Qué hago ahora? Improvisás y volvés al punto de partida.',
  },
  {
    title: '8 semanas sin saber si está funcionando',
    description:
      'Sin métrica clara. Sin progreso medible. Sin razón para seguir.',
  },
]

export const heroTestimonials: Testimonial[] = [
  {
    initials: 'MJ',
    name: 'Matías J.',
    location: 'Buenos Aires',
    quote:
      'Bajé 6 kilos en 8 semanas sin pesarme cada comida. El sistema de recortes inteligentes cambió todo.',
  },
  {
    initials: 'CL',
    name: 'Carolina L.',
    location: 'Rosario',
    quote:
      'Finalmente entiendo por qué mis abdominales no se ven. No era que no entrenara suficiente, era grasa. Esto funciona.',
  },
  {
    initials: 'AP',
    name: 'Andrés P.',
    location: 'La Plata',
    quote:
      'Las rutinas de 25 minutos me permiten entrenar consistente. Nunca pensé que consistencia = resultado.',
  },
]

export const testimonials: Testimonial[] = [
  {
    initials: 'MJ',
    name: 'Matías J.',
    location: 'Buenos Aires',
    tag: 'MegaPack + Torso Definido',
    quote:
      'Bajé grasa consistente porque no tenía que pensar. Las rutinas de 25 minutos funcionan. Los recortes inteligentes de comida no requieren pesada. Esto es lo que buscaba.',
  },
  {
    initials: 'CL',
    name: 'Carolina L.',
    location: 'Rosario',
    tag: 'MegaPack',
    quote:
      'Finalmente un sistema que se adapta a mi vida. No abandono porque no me pide 90 minutos en el gym. Funcionó.',
  },
  {
    initials: 'AP',
    name: 'Andrés P.',
    location: 'La Plata',
    tag: 'MegaPack + Torso Definido',
    quote:
      'El módulo de abdomen cambió todo. Entendí que el abdomen se revela, no se crea. Cuando bajé grasa, se vio el trabajo. Resultó.',
  },
  {
    initials: 'LG',
    name: 'Laura G.',
    location: 'Mendoza',
    tag: 'MegaPack',
    quote:
      'Por primera vez entiendo la comida. No es dieta, son recortes simples. Como lo que como, pero menos. Lógico. Funciona.',
  },
]

export const plans: Plan[] = [
  {
    id: 'megapack',
    emoji: '📘',
    name: 'MEGAPACK DEFINICIÓN INTELIGENTE',
    includes: '6 Tomos + 5 Bonos — Todos los niveles',
    idealFor:
      'Principiantes a intermedios que quieren definir sin complicarse',
    oldPrice: '$24.500',
    price: '$19.900 ARS',
    cta: 'QUIERO MI MEGAPACK AHORA',
    checkoutUrl: 'https://www.nucleofit.shop/cart/52859285602586:1',
  },
  {
    id: 'megapack-torso',
    emoji: '🏆',
    name: 'MEGAPACK + TORSO DEFINIDO',
    featured: true,
    includes: '6 Tomos + 5 Bonos + Módulo Premium Abdomen, Pecho y Hombros',
    idealFor:
      'Quien quiere construir un torso más fuerte, amplio y marcado mientras define',
    oldPrice: '$37.000',
    price: '$27.900 ARS',
    cta: 'QUIERO EL MEGAPACK + TORSO DEFINIDO',
    checkoutUrl: 'https://www.nucleofit.shop/cart/52860388573466:1',
  },
]

export const moduleComparison: ComparisonRow[] = [
  {
    situation: 'Quiero abdomen más marcado pero no sé cómo',
    without: 'Hago crunch al azar',
    with: 'Rutina de 8 semanas específica, calendario incluido',
  },
  {
    situation: 'El pecho se ve plano',
    without: 'Sin trabajo específico',
    with: 'Progresiones de flexión + press estructuradas',
  },
  {
    situation: 'Los hombros no crecen',
    without: 'Ejercicios genéricos',
    with: '5 progresiones de hombros, de fácil a avanzado',
  },
  {
    situation: 'No sé si progreso en torso',
    without: 'Espejo cada día',
    with: 'Test inicial vs test final, métricas claras',
  },
  {
    situation: 'Me duele la espalda cuando entreno',
    without: 'Sin protocolo',
    with: 'Guía antilesión + adaptaciones',
  },
]

export const moduleIncludes: string[] = [
  '51 páginas de contenido práctico',
  '5 pilares del torso explicados en profundidad',
  '10 progresiones desde básico a avanzado',
  '7 rutinas diferentes según tiempo y objetivo',
  'Calendario de 8 semanas paso a paso',
  'Test inicial + test final para medir progreso',
  'Solución de problemas (dolor, estancamiento, poco tiempo)',
  'Integración perfecta con el MegaPack principal',
]

export const costRows: CostRow[] = [
  {
    without: '3 hs de planificación × 40 semanas',
    cost: '120 horas de tu vida por año',
  },
  {
    without: 'Rutinas que abandonás porque no se adaptan',
    cost: 'Frustración + dinero de gym sin usar',
  },
  {
    without: 'Comida pesada e insostenible',
    cost: 'En la Semana 2 abandonás',
  },
  { without: 'Sin saber si funciona', cost: 'Motivación en -10' },
  {
    without: 'Domingo siguiente: el mismo ciclo',
    cost: 'Estrés + falta de hábito',
  },
]

export const faqs: FaqItem[] = [
  {
    question: '¿Sirve para todos los niveles?',
    answer:
      'Sí. El Tomo 3 tiene Rutina A (45 min, avanzado), Rutina B (25 min, intermedio) y Rutina C (10 min, principiante). Además, el Tomo 4 de Anatomía tiene ejercicios desde básico a avanzado. Elegís dónde empezar según tu test inicial.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      '100% digital en PDF. Al comprar recibís acceso inmediato a una carpeta descargable con los 6 tomos + 5 bonos. Podés descargarla a tu computadora, tablet o teléfono. Todo tuyo, para siempre.',
  },
  {
    question: '¿Qué lo diferencia del material online?',
    answer: 'Cuatro diferencias concretas:',
    bullets: [
      {
        label: 'Propio',
        text: 'No depende de internet. Descargás una sola vez y está en tu teléfono para siempre.',
      },
      {
        label: 'Estructurado',
        text: '6 tomos con lógica de progresión. No es información al azar.',
      },
      {
        label: 'Práctico',
        text: 'No es solo teoría. Cada página tiene un protocolo que podés ejecutar hoy mismo.',
      },
      {
        label: 'Integrado',
        text: 'Los 6 tomos + 5 bonos forman un sistema completo: comida + entrenamiento + reglas sin fricción.',
      },
    ],
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      'Sí. 7 días, sin preguntas. Si no es lo que esperabas, devolvemos el 100% de tu dinero. Escribís a soporte.nucleofit@gmail.com y listo. Sin formularios, sin drama.',
  },
  {
    question: '¿Necesito membresía de gym?',
    answer:
      'No. Todas las rutinas tienen versión sin equipamiento (peso corporal). Pero si tenés gym, mejor: algunas progresiones avanzan con peso.',
  },
  {
    question: '¿Es para hombres, mujeres o ambos?',
    answer:
      'Para ambos. El sistema funciona igual: bajás grasa, construís músculo y te ves más definido. El género no importa, la fisiología es la misma.',
  },
  {
    question: '¿Cuánto tiempo le dedico por día?',
    answer: 'Según lo que elijas:',
    bullets: [
      { label: 'Rutina A', text: '45 minutos, 3 veces por semana.' },
      { label: 'Rutina B', text: '25 minutos, 3-4 veces por semana.' },
      {
        label: 'Rutina C',
        text: '10 minutos, 5 veces por semana (mantenés el hábito).',
      },
      {
        label: 'Comida',
        text: 'Nada especial. Comés normal y aplicás recortes inteligentes.',
      },
    ],
  },
  {
    question: '¿Qué pasa después de las 8 semanas?',
    answer:
      'El Tomo 6 (Plan 8 Semanas) termina con un capítulo de “Continuidad post 8 semanas” con 4 opciones:',
    bullets: [
      { text: 'Repetir 8 semanas más (progresión lenta).' },
      { text: 'Pasar a ganancia de músculo (déficit → superávit).' },
      {
        text: 'Rotación de énfasis (foco en pecho, foco en hombros, foco en abdomen).',
      },
      { text: 'Aumentar intensidad gradualmente.' },
    ],
  },
]
